export class Device {
  id: string;
  identifier: string;
  name: string;
  model: string;
  endPoint: string;
  description: string;
  lastCallDate: Date;
  lastReadingRequestDate: Date;
  lastConfigurationSendingDate: Date;
  connector: string;
  sendingStatus: SendingStatus;
  loading: boolean;
  canRequestConfiguration: boolean;

  constructor(obj: any) {
    this.id                           = obj?.id;
    this.name                         = obj?.name;
    this.identifier                   = obj?.identifier;
    this.model                        = obj?.model;
    this.endPoint                     = obj?.endPoint;
    this.description                  = obj?.description;
    this.lastCallDate                 = obj?.lastCallDate;
    this.lastReadingRequestDate       = obj?.lastReadingRequestDate;
    this.lastConfigurationSendingDate = obj?.lastConfigurationSendingDate;
    this.connector                    = obj?.connector;
    this.sendingStatus                = SendingStatus.Undefined;
    this.loading                      = false;
    this.canRequestConfiguration      = false;
    if (obj && obj !== null) {
      if (!obj.lastReadingRequestDate || obj.lastReadingRequestDate === null) {
        this.canRequestConfiguration = true;
      } else {
        const dt = new Date(obj.lastReadingRequestDate).getTime();
        const now = new Date().getTime();
        if (Math.floor((now - dt) / 60000) >= 10) {
          this.canRequestConfiguration = true;
        }
      }
    }
  }
}

export enum SendingStatus {
  Undefined = 'white',
  Unknown = '#D3D3D3',
  Sending = '#FFA500',
  Sent    = '#FF69B4',
  Ack     = '#9ACD32',
  Error   = '#FF1212',
}
